/**
 * EngineBadge.jsx
 *
 * Kullanılan arama motorunu (pgvector veya faiss) görsel olarak gösterir.
 * SOLID - Single Responsibility: Sadece engine gösteriminden sorumludur.
 * Router'ın seçtiği motoru response'dan alıp otomatik renklendiririz.
 */

import React from "react";

const ENGINE_CONFIG = {
  pgvector: {
    label: "pgvector",
    className: "engine-badge engine-badge--pgvector",
  },
  faiss: {
    label: "FAISS",
    className: "engine-badge engine-badge--faiss",
  },
};

function EngineBadge({ engine }) {
  const config = ENGINE_CONFIG[engine] || {
    label: engine,
    className: "engine-badge engine-badge--unknown",
  };

  return (
    <span className={config.className} aria-label={`Arama motoru: ${config.label}`}>
      <span className="engine-badge__dot" aria-hidden="true" />
      {config.label}
    </span>
  );
}

export default EngineBadge;
